// <fp-sticky-cta watch="#selector"> shows its bar (.fp-sticky-cta) once the watched element
// (usually the main CTA) has scrolled out of view, and hides it again when it comes back.
// Without a watch target the bar shows after the first 300px of scroll.
// Adds body.fp-sticky-cta-on while visible so page content is not covered.

class FpStickyCta extends HTMLElement {
  connectedCallback() {
    this.bar = this.querySelector('.fp-sticky-cta') || this;
    const target = this.getAttribute('watch') && document.querySelector(this.getAttribute('watch'));

    if (target && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(([entry]) => {
        const above = entry.boundingClientRect.top < 0;
        this.toggle(!entry.isIntersecting && above);
      });
      this.observer.observe(target);
    } else {
      this.onScroll = () => this.toggle(window.scrollY > 300);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    this.toggle(false);
  }

  toggle(show) {
    this.bar.classList.toggle('is-showing', show);
    document.body.classList.toggle('fp-sticky-cta-on', show);
    for (const el of this.bar.querySelectorAll('a, button')) {
      if (show) el.removeAttribute('tabindex');
      else el.setAttribute('tabindex', '-1');
    }
  }
}

if (!customElements.get('fp-sticky-cta')) customElements.define('fp-sticky-cta', FpStickyCta);
